import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { timeout } from 'rxjs/operators';
import { BaseService } from 'src/app/shared/services/base.service';
import { environment } from 'src/environments/environment';
@Injectable({ providedIn: 'root' })
export class SolicitationService extends BaseService {
    changeUserData(model: any) {
        delete model.registration;
        let url = environment.portalApi + '/solicitation/change-user-data';
        return this.http.post(url, model, { headers: this.createHeader() }).pipe(
            timeout(10 * 60 * 1000) //10 minutes
        );
    }
    changeUserBankData(model: any) {
        let url = environment.portalApi + '/solicitation/change-user-bank';
        return this.http.post(url, model, { headers: this.createHeader() });
    }
    getPhoneChangedcode(params: any): Observable<string> {
        let url = environment.portalApi + '/solicitation/GetPhoneChangeCode?' + this.paramsToQueryString(params);
        return this.http.get(url, {
            headers: this.createHeader(),
            responseType: 'text'
        });
    }
    getEmailChangedcode(params: any): Observable<string> {
        let url = environment.portalApi + '/solicitation/GetEmailChangeCode?' + this.paramsToQueryString(params);
        return this.http.get(url, {
            headers: this.createHeader(),
            responseType: 'text'
        });
    }

    

    getNumberChangedcode(params: any): Observable<string> {
        let url = environment.portalApi + '/solicitation/GetPhoneChangeCode?' + this.paramsToQueryString(params);
        return this.http.get(url, {
            headers: this.createHeader(),
            responseType: 'text'
        });
    }

    validatePhoneChangedcode(params: any) {
        let url = environment.portalApi + '/solicitation/ValidatePhoneChangeCode?' + this.paramsToQueryString(params);
        return this.http.get(url, { headers: this.createHeader() });
    }
    validateEmailChangedcode(params: any) {
        let url = environment.portalApi + '/solicitation/ValidateEmailChangeCode?' + this.paramsToQueryString(params);
        return this.http.get(url, { headers: this.createHeader() });
    }
    getZipCodeParams(zipCode: any) {
        const url = `${environment.portalApi}/solicitation/contact/${zipCode}`;
        return this.http.get(url, { headers: this.createHeader() });
    }
    listSolicitations(filter: any) {
        let url = `${environment.portalApi}/solicitation/listSolicitation`;
        if (filter)
            url += "?" + this.paramsToQueryString(filter);
        return this.http.get(url, { headers: this.createHeader() });
    }
    listSolicitationTypes() {
        let url = `${environment.portalApi}/solicitation/ListSolicitationType`;
        return this.http.get(url, { headers: this.createHeader() });
    }
}
